import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: GamePreviewFlow = {
  gameId: null,
  screen: null,
  gameType: null,
};

const previewSlice = createSlice({
  name: 'preview',
  initialState,
  reducers: {
    setGamePreview(state, action: PayloadAction<Partial<GamePreviewFlow>>) {
      Object.assign(state, action.payload);
    },
  },
});

export const { setGamePreview } = previewSlice.actions;

export default previewSlice.reducer;
